import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const card: ThemeUICSSObject = {
  p: spacing(4),
  border: '1px solid',
  // borderColor: 'baseGrey',
  bg: 'palette.background.paper',
  zIndex: 1,
  width: '430px',
  maxWidth: '90vw',
  borderColor: 'palette.gray.750',
  borderRadius: '8px',
};

export default card;
